import { render, staticRenderFns } from "./ezCmsStaahMax.vue?vue&type=template&id=37f81585&scoped=true"
import script from "./ezCmsStaahMax.vue?vue&type=script&lang=js"
export * from "./ezCmsStaahMax.vue?vue&type=script&lang=js"
import style0 from "./ezCmsStaahMax.vue?vue&type=style&index=0&id=37f81585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f81585",
  null
  
)

export default component.exports